import type { UserRef } from '../api/types'

// 소유자를 부르는 말. 화면은 사람을 이름으로 부르고, 이름을 적지 않은 사람만 아이디로 부른다.
// 이름은 소유자 참조에 실려 오므로 사용자 목록과 합치지 않는다 — 그 목록에 없는 사람(숨은 계정)도,
// 그 목록을 읽지 못한 때도 같은 말로 선다. 찾기는 이름과 아이디를 둘 다 본다.

/** 소유자를 부르는 말 — 이름, 없으면 아이디. */
export function ownerLabel(owner: UserRef): string {
  return owner.name ?? owner.username
}
